import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const MonospaceBlock = styled(Box)(({ theme }) => ({
  padding: theme.spacing(1.5),
  backgroundColor: theme.palette.background.paper,
  borderRadius: Number(theme.shape.borderRadius) / 2,
  border: `1px dashed ${theme.palette.grey[300]}`,
  fontSize: '0.875rem',
  lineHeight: 1.5,
  fontFamily: 'monospace',
}));
